import { useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { UserQueryKeys } from '../config/queryKeys';
import { BFFClient } from '../lib/BFFClient';
import { getRequestHeaders } from '../lib/headers';
import { type UserDetail, UserDetailSchema } from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

export interface UserDetailQueryVariables {
  userId: string;
  withRolesMap?: boolean;
}

export function useUser<TData = UserDetail>(
  variables: UserDetailQueryVariables,
  options?: PresetUseQueryOptions<UserDetail, TData>,
) {
  const session = useWmgSession();

  const { userId, ...searchParams } = variables;

  const { data: user, ...query } = useQuery({
    queryKey: UserQueryKeys.detail(variables),
    queryFn: async () => {
      const data = await BFFClient.get(`users/${userId}`, {
        headers: getRequestHeaders(session.token),
        searchParams,
      }).json();

      return UserDetailSchema.parse(data);
    },
    enabled: Boolean(userId),
    ...options,
  });

  return { user, ...query };
}
